<template>
  <div
    :class="$style.login"
    :style="{
      '--keyboard-height': keyboard.height,
    }"
  >
    <div :class="$style.form" ref="form">
      <div class="radio-group">
        <div class="radio-group__title">{{ $t('login.vistor_type') }}</div>
        <input id="visitor" type="radio" name="level" v-model="login.level" :value="1">
        <label for="visitor">
          {{ $t('login.visitor') }}
        </label>
        <input id="worker" type="radio" name="level" v-model="login.level" :value="2">
        <label for="worker">
          {{ $t('login.worker') }}
        </label>
      </div>

      <div class="input-group">
        <input id="name" :class="$style.input" @focus="show" type="text" v-model="login.name">
        <label for="name">{{ $t('login.name') }}</label>
      </div>
      <div class="input-group">
        <input id="company" :class="$style.input" @focus="show" type="text" v-model="login.company">
        <label for="company">{{ $t('login.company') }}</label>
      </div>

      <div class="btn" @click="verify">{{ $t('login.verify') }}</div>
    </div>
    <transition name="keyboard-transition">
      <vue-keyboard
        v-if="keyboard.visible"
        :accept="accept"
        :input="keyboard.input"
        :next="next"
        :cancel="hide"
        ref="keyboard"
      />
    </transition>
  </div>
</template>

<style lang="scss" module>
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form {
    display: grid;
    grid-gap: 1em;
    max-width: 20em;
    min-width: 15em;
    transition: all 1s;
    transform: translateY(calc(var(--keyboard-height) * -0.5));
  }

  .keyboard-transition {
    &-enter-active, &-leave-active {
      transition: opacity .7s, transform .9s;
      position: absolute;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(50%);
    }
    &-leave-to {
      transition: opacity .3s, transform .5s;
    }
  }
</style>

<script>
// @ is an alias to /src
import axios from 'axios';
import VueKeyboard from '@/components/Keyboard/VueKeyboard';

// import { ipcRenderer } from 'electron';

export default {
  name: 'home',
  components: {
    VueKeyboard,
  },
  data() {
    return {
      login: {
        name: null,
        company: null,
        level: null,
      },
      inputs: null,
      keyboard: {
        visible: false,
        input: null,
        height: 0,
        options: {
          useKbEvents: true,
          preventClickEvent: true,
        },
      },
    };
  },
  mounted() {
    this.inputs = [...this.$refs.form.querySelectorAll('input[type=text]')];
    this.$store.dispatch('resetAll');
  },
  methods: {
    // printWindow() {
    //   window.print();
    // },
    show(e) {
      this.keyboard.input = e.target;

      if (!this.keyboard.visible) {
        this.keyboard.visible = true;
        this.$nextTick(() => {
          this.keyboard.height = `${this.$refs.keyboard.$el.clientHeight}px`;
        });
      }
    },
    accept() {
      if (this.inputs.indexOf(this.keyboard.input) === this.inputs.length - 1) {
        this.hide();
        this.verify();
      } else {
        this.next();
      }
    },
    blur() {
      this.keyboard.visible = false;
      this.keyboard.height = 0;
    },
    hide() {
      this.keyboard.visible = false;
      this.keyboard.height = 0;
      this.keyboard.input.blur();
    },
    next() {
      const index = this.inputs.indexOf(this.keyboard.input);
      this.inputs[index + 1].focus();
    },
    verify() {
      this.$store.dispatch('getVisitor', this.login).then(({ needs_instruction }) => {
        if (needs_instruction) {
          this.$router.push({ name: 'clues' });
        } else {
          this.$router.push({ name: 'status', params: { passed: true } });
        }
      });
    },
    activeInputClass(input) {
      return this.keyboard.visible && this.keyboard.input === input;
    },
  },
};
</script>
